document.addEventListener('DOMContentLoaded',()=>{
 const menu=document.querySelector('[data-mobile-menu]');
 const nav=document.querySelector('[data-main-nav]');
 if(menu&&nav) menu.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');menu.setAttribute('aria-expanded',String(open));});
 document.querySelectorAll('[data-back-button]').forEach(btn=>btn.addEventListener('click',()=>{
   if(window.history.length>1){window.history.back()}else{window.location.href='/collections/all'}
 }));
});
(() => {
 const key='karaar-favorites';
 const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'[]')}catch(e){return []}};
 const write=list=>{try{localStorage.setItem(key,JSON.stringify(list))}catch(e){}};
 const escapeHTML=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const syncButtons=()=>{
   const list=read();
   document.querySelectorAll('[data-favorite]').forEach(btn=>{
     const active=list.includes(btn.dataset.favorite);
     btn.classList.toggle('is-favorite',active);
     btn.setAttribute('aria-pressed',String(active));
     btn.setAttribute('aria-label',active?'إزالة من المفضلة':'إضافة إلى المفضلة');
     btn.textContent=active?'♥':'♡';
   });
 };
 const renderFavorites=async()=>{
   const grid=document.querySelector('[data-favorites-grid]');
   const empty=document.querySelector('[data-favorites-empty]');
   if(!grid||!empty)return;
   const handles=read();
   grid.innerHTML='';
   if(!handles.length){empty.hidden=false;return}
   empty.hidden=true;
   for(const handle of handles){
     try{
       const response=await fetch(`/products/${encodeURIComponent(handle)}.js`);
       if(!response.ok)throw new Error('Product unavailable');
       const p=await response.json();
       const image=p.featured_image||((p.images||[])[0])||'';
       const price=(p.price/100).toLocaleString('en-US',{minimumFractionDigits:3,maximumFractionDigits:3});
       const card=document.createElement('article');
       card.className='product-card favorite-product-card';
       card.innerHTML=`<a href="/products/${encodeURIComponent(p.handle)}" class="product-media">${image?`<img src="${escapeHTML(image)}" alt="${escapeHTML(p.title)}" loading="lazy">`:'<span class="product-placeholder">✦</span>'}</a>
       <div class="product-info"><a class="product-title" href="/products/${encodeURIComponent(p.handle)}">${escapeHTML(p.title)}</a>
       <div class="price">IQD ${price}</div><a class="button" href="/products/${encodeURIComponent(p.handle)}">عرض العطر ←</a>
       <button type="button" class="favorite-remove-button" data-remove-favorite="${escapeHTML(p.handle)}">إزالة من المفضلة</button></div>`;
       grid.appendChild(card);
     }catch(error){
       // Keep stale handles out of the user's list if a product no longer exists.
       write(read().filter(x=>x!==handle));
     }
   }
   if(!grid.children.length)empty.hidden=false;
 };
 document.addEventListener('click',event=>{
   const btn=event.target.closest('[data-favorite]');
   if(btn){
     const handle=btn.dataset.favorite;
     let list=read();
     list=list.includes(handle)?list.filter(x=>x!==handle):[...list,handle];
     write(list);syncButtons();
     if(document.querySelector('[data-favorites-grid]'))renderFavorites();
   }
   const remove=event.target.closest('[data-remove-favorite]');
   if(remove){write(read().filter(x=>x!==remove.dataset.removeFavorite));renderFavorites();syncButtons();}
 });
 document.addEventListener('DOMContentLoaded',()=>{syncButtons();renderFavorites()});
 syncButtons();
})();

// Cart quantities save automatically; checkout uses Shopify's standard checkout route.
document.addEventListener('change', async (event) => {
  const input = event.target.closest('[data-cart-quantity]');
  if (!input) return;
  const quantity = Math.max(1, parseInt(input.value || '1', 10));
  input.value = String(quantity);
  input.disabled = true;
  const status = document.querySelector('[data-cart-status]');
  if (status) status.textContent = 'جارٍ حفظ الكمية…';
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({id: input.dataset.lineKey, quantity})
    });
    if (!response.ok) throw new Error('Cart update failed');
    window.location.reload();
  } catch (error) {
    input.disabled = false;
    if (status) status.textContent = 'تعذر حفظ الكمية. حدّث الصفحة وحاول مجددًا.';
  }
});

// Hero slideshow: automatic rotation and manually selectable dots.
(() => {
  const setSlide = (hero, index) => {
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    if (!slides.length) return;
    const next = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === next));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === next));
    hero.dataset.activeSlide = String(next);
  };
  const initSlideshows = () => {
    document.querySelectorAll('[data-hero-slideshow]').forEach((hero) => {
      if (hero.dataset.autoplayInitialized === 'true') return;
      hero.dataset.autoplayInitialized = 'true';
      const slides = hero.querySelectorAll('[data-hero-slide]');
      if (slides.length < 2) return;
      window.setInterval(() => setSlide(hero, Number(hero.dataset.activeSlide || 0) + 1), 4500);
    });
  };
  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-hero-dot]');
    if (!dot) return;
    const hero = dot.closest('[data-hero-slideshow]');
    if (hero) setSlide(hero, Number(dot.dataset.index));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSlideshows);
  else initSlideshows();
})();

// Load the next page of products into the current grid, ten products at a time.
document.addEventListener('click', async (event) => {
  const link = event.target.closest('[data-load-more-products]');
  if (!link) return;
  event.preventDefault();
  if (link.dataset.loading === 'true') return;
  const section = link.closest('section') || document;
  const grid = section.querySelector('[data-featured-products-grid]') || section.querySelector('.product-grid');
  if (!grid) { window.location.href = link.href; return; }
  const originalText = link.textContent.trim();
  link.dataset.loading = 'true';
  link.textContent = 'جارٍ تحميل المنتجات…';
  try {
    const response = await fetch(link.href, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Could not load next products page');
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextGrid = doc.querySelector('[data-featured-products-grid]') || doc.querySelector('.product-grid');
    if (!nextGrid || !nextGrid.children.length) { link.closest('nav')?.remove(); return; }
    [...nextGrid.children].forEach((card) => grid.appendChild(card));
    const nextLink = doc.querySelector('[data-load-more-products]');
    if (nextLink) {
      link.href = nextLink.href;
      link.textContent = originalText;
      link.dataset.loading = 'false';
    } else {
      link.closest('nav')?.remove();
    }
  } catch (error) {
    link.textContent = 'تعذر التحميل — حاول مجددًا';
    link.dataset.loading = 'false';
  }
});
